namespace Ir.Components.Workbook.ToolBar.ReportToolBar {
    interface IReportToolBarViewModel {
        config: WorkbookConfig;
        dxToolbarConfig: DevExpress.ui.dxToolbar.Properties;        

        groupByLabel: KnockoutObservable<string>;
        
        topBottomPopoverConfig: DevExpress.ui.dxPopover.Properties;
        topBottomSelectBoxConfig: DevExpress.ui.dxSelectBox.Properties;
        topBottomValueConfig: DevExpress.ui.dxNumberBox.Properties;
        topBottomFieldSelectBoxConfig: DevExpress.ui.dxSelectBox.Properties;
        applyTopBottomButtonConfig: DevExpress.ui.dxButton.Properties;
        
        topBottomPopover: DevExpress.ui.dxPopover;
        $topBottomSpan: JQuery<HTMLElement>;
        topBottomText: KnockoutObservable<string>;
        topBottomLabel: KnockoutObservable<string>;
        $topBottomButton: JQuery<HTMLElement>;

        topBottomGroupByPopoverConfig: DevExpress.ui.dxPopover.Properties;
        topBottomGroupBySelectBoxConfig: DevExpress.ui.dxSelectBox.Properties;
        topBottomGroupByValueConfig: DevExpress.ui.dxNumberBox.Properties;
        topBottomGroupByFieldSelectBoxConfig: DevExpress.ui.dxSelectBox.Properties;
        applyTopBottomGroupByButtonConfig: DevExpress.ui.dxButton.Properties;

        topBottomGroupByPopover: DevExpress.ui.dxPopover;
        $topBottomGroupBySpan: JQuery<HTMLElement>;
        topBottomGroupByText: KnockoutObservable<string>;
        topBottomGroupByLabel: KnockoutObservable<string>;
        $topBottomGroupByButton: JQuery<HTMLElement>;

        disableIsNotReportConfig: KnockoutObservable<boolean>;
        visibleIsReportConfig: KnockoutObservable<boolean>;

        $reportTypeAction: JQuery<HTMLElement>;
        reportTypeActionConfig: DevExpress.ui.dxActionSheet.Properties;
        reportTypeAction: DevExpress.ui.dxActionSheet;
        reportTypeIcon: KnockoutComputed<string>;
        reportTypeIconText: KnockoutComputed<string>;
    }

    let dxToolbarComponent: DevExpress.ui.dxToolbar;
    let analyzeByLookup: DevExpress.ui.dxLookup;
    let groupByLookup: DevExpress.ui.dxLookup;
    export function getViewModel(this: IReportToolBarViewModel, params: any, componentInfo) {
        let self = this;

        self.config = params.config as WorkbookConfig;

        self.groupByLabel = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
            let reportConfig = this()?.drilldownManager?.activeReportConfig;
            if (!reportConfig) {
                return "Group By";
            }
            
            if (reportConfig.reportType() === ReportTypeEnum.Pivot) {
                return "Pivot On";
            }
            else {
                return `Group By`;
            }
        }, self.config.activeTabOrWidget);

        let metrics = ko.computed(function (this: KnockoutObservable<ITabOrWidget>): Array<MetricField> {
            let reportConfig = this()?.drilldownManager?.activeReportConfig;
            if (!reportConfig) {
                return [];
            }

            let metricList = reportConfig.reportType() === ReportTypeEnum.Analysis ? reportConfig.fields().filter(x => x.isMetric) : reportConfig.metricFields().slice();
            metricList.unshift({
                queryName: null,
                displayName: "Select a metric",
            } as any);
            return metricList as any;
        }, self.config.activeTabOrWidget);

        let metricName = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
            var tabOrWidget = this();
            if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                return "";
            }
            let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
            let queryName = reportConfig.topBottomFieldName();
            if (queryName === null) {
                return "";
            }
            let metric = metrics().find(x => x.queryName === queryName);
            return replaceBasicHtmlContent(metric?.displayName?.() ?? "");
        }, self.config.activeTabOrWidget);

        self.topBottomLabel = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
            var tabOrWidget = this();
            if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                return "Top";
            }
            let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
            if (reportConfig.topBottom() == TopBottomEnum.Bottom) {
                return "Bottom";
            }
            else {
                return `Top`;
            }
        }, self.config.activeTabOrWidget);
        
        self.topBottomText = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
            var tabOrWidget = this();
            if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                return "All";
            }
            let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
            if (reportConfig.topBottom() == TopBottomEnum.All) {
                return "All";
            }
            else {
                return `${reportConfig.resultCount()} by ${metricName()}`;
            }
        }, self.config.activeTabOrWidget);

        self.$topBottomSpan = $(`<span data-bind="text: $component.topBottomText"></span>`);


        self.applyTopBottomButtonConfig = {
            icon: "save",
            type: "default",
            onClick(e) {
                self.topBottomPopover.hide();
            }
        }

        let metricNameGroupBy = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
            var tabOrWidget = this();
            if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                return "";
            }
            let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
            let queryName = reportConfig.topBottomGroupByFieldName();
            if (queryName === null) {
                return "";
            }
            let metric = metrics().find(x => x.queryName === queryName);
            return metric?.displayName() ?? "";
        }, self.config.activeTabOrWidget);

        self.topBottomGroupByLabel = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
            var tabOrWidget = this();
            if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                return "Top";
            }
            let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
            if (reportConfig.topBottomGroupBy() == TopBottomEnum.Bottom) {
                return "Bottom";
            }
            else {
                return `Top`;
            }
        }, self.config.activeTabOrWidget);
        
        self.topBottomGroupByText = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
            var tabOrWidget = this();
            if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                return "All";
            }
            let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
            if (reportConfig.topBottomGroupBy() == TopBottomEnum.All) {
                return "All";
            }
            else {
                return `${reportConfig.resultCountGroupBy()} by ${metricNameGroupBy()}`;
            }
        }, self.config.activeTabOrWidget);

        self.$topBottomGroupBySpan = $(`<span data-bind="text: $component.topBottomGroupByText"></span>`);


        self.applyTopBottomGroupByButtonConfig = {
            icon: "save",
            type: "default",
            onClick(e) {
                self.topBottomGroupByPopover.hide();
            }
        }

        self.disableIsNotReportConfig = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
            return !this() || !this().drilldownManager?.isReportConfig;
        }, self.config.activeTabOrWidget);

        self.visibleIsReportConfig = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
            return this()?.itemConfig()?.isReportConfig ?? false;
        }, self.config.activeTabOrWidget);

        self.reportTypeIcon = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
            if (!this()?.itemConfig()?.isReportConfig) {
                workbook.workbookConfig.workbookHelper.getTabIcon(self.config.activeTab().tabType(), WidgetType.Report, true);
            }
            return workbook.workbookConfig.workbookHelper.getTabIcon(self.config.activeTab().tabType(), this().drilldownManager?.getActiveWidget().widgetType, true);
        }, self.config.activeTabOrWidget);

        self.reportTypeIconText = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
            if (!this()?.itemConfig()?.isReportConfig) {
                return reportTypeToString(ReportTypeEnum.Analysis);
            }

            return reportTypeToString(this().drilldownManager?.activeReportConfig?.reportType());
        }, self.config.activeTabOrWidget);

        self.reportTypeActionConfig = {
            showTitle: true,
            title: "Change Report Type",
            showCancelButton: true,
            usePopover: true,
            onInitialized(e) {
                self.reportTypeAction = e.component;
            },
            items: [
                {
                    text: "Report",
                    icon: "ms ir-report-icon",
                    visible: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        if (!this()?.itemConfig()?.isReportConfig) {
                            return false;
                        }
                        return this().drilldownManager.activeReportConfig.reportType() !== ReportTypeEnum.Analysis;
                    }, self.config.activeTabOrWidget),
                    widgetType: WidgetType.Report,
                }, 
                {
                    text: "Chart",
                    icon: "ms ir-chart-icon",
                    visible: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        if (!this()?.itemConfig()?.isReportConfig) {
                            return false;
                        }
                        return this().drilldownManager.activeReportConfig.reportType() !== ReportTypeEnum.Chart;
                    }, self.config.activeTabOrWidget),
                    widgetType: WidgetType.Chart,
                },
                {
                    text: "Pivot",
                    icon: "ms ir-pivot-icon",
                    visible: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        if (!this()?.itemConfig()?.isReportConfig) {
                            return false;
                        }
                        return this().drilldownManager.activeReportConfig.reportType() !== ReportTypeEnum.Pivot;
                    }, self.config.activeTabOrWidget),
                    widgetType: WidgetType.Pivot,
                },
            ],
            onItemClick(e) {
                let reportConfig = self.config.activeTabOrWidget().drilldownManager.activeReportConfig;
                if (e.itemData.widgetType !== WidgetType.Pivot || reportConfig.groupReportId() > 0 || reportConfig.groupReportFields()[0]?.fields()?.length > 0) {
                    //self.config.activeTabOrWidget().drilldownManager.rollUp();
                    reportConfig.changeReportType(self.config.activeTabOrWidget(), e.itemData.widgetType);
                }
                else { 
                    DevExpress.ui.notify({ message: `Can't change to Pivot without Group By.`, type: "error", position: { of: self.$reportTypeAction, at: 'bottom', my: 'left' }, width: 300 });
                    let $groupBy = $(".group-by", componentInfo.element);
                    $groupBy.addClass("highlight animate__animated animate__headShake");
                    setTimeout(() => {
                        $groupBy.removeClass("highlight animate__animated animate__headShake");
                    }, 2000);
                }
            }
        };

        self.dxToolbarConfig = {
            items: getItems(self),
            onInitialized(e) {
                dxToolbarComponent = e.component;
            }
        };

        let oldValues = {
            topBottom: TopBottomEnum.All,
            topBottomFieldName: "",
            resultCount: 0,

            topBottomGroupBy: TopBottomEnum.All,
            topBottomGroupByFieldName: "",
            resultCountGroupBy: 0,
        };

        self.topBottomPopoverConfig = {
            width: 350,
            hideOnOutsideClick: true,
            onShowing(e) {
                let reportConfig = self.config.activeTabOrWidget().drilldownManager.activeReportConfig;
                oldValues.topBottom = reportConfig.topBottom();
                oldValues.topBottomFieldName = reportConfig.topBottomFieldName();
                oldValues.resultCount = reportConfig.resultCount();
            },
            onHiding(e) {
                if (self.config.activeTabOrWidget()?.itemConfig()?.isReportConfig) {
                    let reportConfig = self.config.activeTabOrWidget().drilldownManager.activeReportConfig;
                    if (reportConfig.topBottom() === TopBottomEnum.All) {
                        reportConfig.topBottomFieldName(null);
                    }
                    else {
                        if (reportConfig.topBottomFieldName() === null) {
                            reportConfig.topBottom(TopBottomEnum.All);
                            DevExpress.ui.notify({ message: `Top/Bottom Metric not selected.`, type: "error", position: { of: self.$topBottomButton, at: 'right', my: 'left' }, width: 300 });
                        }
                    }
                    if (oldValues.topBottom !== reportConfig.topBottom() || oldValues.topBottomFieldName !== reportConfig.topBottomFieldName() || oldValues.resultCount !== reportConfig.resultCount()) {
                        //self.config.activeTabOrWidget().drilldownManager.rollUp();
                        reportConfig.saveTopBottom(self.config.activeTabOrWidget(), self.$topBottomButton, oldValues);
                    }
                }
            },
            onInitialized(e) {
                self.topBottomPopover = e.component;
            },
            animation: {
                show: {
                    type: 'pop',
                    from: { scale: 0 },
                    to: { scale: 1 },
                },
                hide: {
                    type: 'fade',
                    from: 1,
                    to: 0,
                },
            },
        };

        self.topBottomGroupByPopoverConfig = {
            width: 350,
            hideOnOutsideClick: true,
            onShowing(e) {
                let reportConfig = self.config.activeTabOrWidget().drilldownManager.activeReportConfig;
                oldValues.topBottomGroupBy = reportConfig.topBottom();
                oldValues.topBottomGroupByFieldName = reportConfig.topBottomGroupByFieldName();
                oldValues.resultCountGroupBy = reportConfig.resultCountGroupBy();
            },
            onHiding(e) {
                if (self.config.activeTabOrWidget()?.itemConfig()?.isReportConfig) {
                    let reportConfig = self.config.activeTabOrWidget().drilldownManager.activeReportConfig;
                    if (reportConfig.topBottomGroupBy() === TopBottomEnum.All) {
                        reportConfig.topBottomGroupByFieldName(null);
                    }
                    else {
                        if (reportConfig.topBottomGroupByFieldName() === null) {
                            reportConfig.topBottomGroupBy(TopBottomEnum.All);
                            DevExpress.ui.notify({ message: `Top/Bottom Metric not selected.`, type: "error", position: { of: self.$topBottomButton, at: 'right', my: 'left' }, width: 300 });
                        }
                    }
                    if (oldValues.topBottomGroupBy !== reportConfig.topBottomGroupBy() || oldValues.topBottomGroupByFieldName !== reportConfig.topBottomGroupByFieldName() || oldValues.resultCountGroupBy !== reportConfig.resultCountGroupBy()) {
                        reportConfig.saveTopBottom(self.config.activeTabOrWidget(), self.$topBottomGroupByButton, oldValues);
                    }
                }
            },
            onInitialized(e) {
                self.topBottomGroupByPopover = e.component;
            },
            animation: {
                show: {
                    type: 'pop',
                    from: { scale: 0 },
                    to: { scale: 1 },
                },
                hide: {
                    type: 'fade',
                    from: 1,
                    to: 0,
                },
            },
        };

        let disabledAll = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
            var tabOrWidget = this();
            if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                return true;
            }
            let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
            return reportConfig.topBottom() === TopBottomEnum.All;
        }, self.config.activeTabOrWidget) as any;

        self.topBottomSelectBoxConfig = {
            value: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                var tabOrWidget = this();
                if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                    return null;
                }
                let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                return reportConfig.topBottom();
            }, self.config.activeTabOrWidget),
            displayExpr: 'text',
            valueExpr: 'id',
            items: [
                { id: TopBottomEnum.All, text: 'All' },
                { id: TopBottomEnum.Top, text: 'Top' },
                { id: TopBottomEnum.Bottom, text: 'Bottom' }
            ],
            width: 80,
            onValueChanged(e) {
                let tabOrWidget = self.config.activeTabOrWidget();
                if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                    return;
                }
                let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                if (e.value !== reportConfig.topBottom()) {
                    reportConfig.topBottom(e.value);
                }

                repaintToolbar();
            },
        };
        self.topBottomValueConfig = {
            format: '0#',
            value: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                var tabOrWidget = this();
                if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                    return null;
                }
                let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                return reportConfig.resultCount();
            }, self.config.activeTabOrWidget) as any,
            step: 1,
            showSpinButtons: isMobile() ? false : true,
            min: 1,
            width: 70,
            disabled: disabledAll,
            onValueChanged(e) {
                let tabOrWidget = self.config.activeTabOrWidget();
                if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                    return;
                }
                let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                if (e.value !== reportConfig.resultCount()) {
                    reportConfig.resultCount(e.value);
                }

                repaintToolbar();
            },
        };

        self.topBottomFieldSelectBoxConfig = {
            value: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                var tabOrWidget = this();
                if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                    return null;
                }
                let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                return reportConfig.topBottomFieldName();
            }, self.config.activeTabOrWidget),
            displayExpr(e) {
                return replaceBasicHtmlContent(typeof e.displayName === "function" ? e.displayName() : e.displayName);
            },
            valueExpr: 'queryName',
            items: metrics as any,
            width: 140,
            onValueChanged(e) {
                let tabOrWidget = self.config.activeTabOrWidget();
                if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                    return;
                }
                let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                if (e.value !== reportConfig.topBottomFieldName()) {
                    reportConfig.topBottomFieldName(e.value);
                }

                repaintToolbar();
            },
            disabled: disabledAll,
        };

        let disabledAllGroupBy = ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
            var tabOrWidget = this();
            if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                return true;
            }
            let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
            return reportConfig.topBottomGroupBy() === TopBottomEnum.All;
        }, self.config.activeTabOrWidget) as any;

        self.topBottomGroupBySelectBoxConfig = {
            value: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                var tabOrWidget = this();
                if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                    return null;
                }
                let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                return reportConfig.topBottomGroupBy();
            }, self.config.activeTabOrWidget),
            displayExpr: 'text',
            valueExpr: 'id',
            items: [
                { id: TopBottomEnum.All, text: 'All' },
                { id: TopBottomEnum.Top, text: 'Top' },
                { id: TopBottomEnum.Bottom, text: 'Bottom' }
            ],
            width: 80,
            onValueChanged(e) {
                let tabOrWidget = self.config.activeTabOrWidget();
                if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                    return;
                }
                let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                if (e.value !== reportConfig.topBottomGroupBy()) {
                    reportConfig.topBottomGroupBy(e.value);
                }

                repaintToolbar();
            },
        };
        self.topBottomGroupByValueConfig = {
            format: '0#',
            value: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                var tabOrWidget = this();
                if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                    return null;
                }
                let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                return reportConfig.resultCountGroupBy();
            }, self.config.activeTabOrWidget) as any,
            step: 1,
            showSpinButtons: isMobile() ? false : true,
            min: 1,
            width: 70,
            disabled: disabledAllGroupBy,
            onValueChanged(e) {
                let tabOrWidget = self.config.activeTabOrWidget();
                if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                    return;
                }
                let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                if (e.value !== reportConfig.resultCountGroupBy()) {
                    reportConfig.resultCountGroupBy(e.value);
                }

                repaintToolbar();
            },
        };

        self.topBottomGroupByFieldSelectBoxConfig = {
            value: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                var tabOrWidget = this();
                if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                    return null;
                }
                let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                return reportConfig.topBottomGroupByFieldName();
            }, self.config.activeTabOrWidget),
            displayExpr(e) {
                return replaceBasicHtmlContent(typeof e?.displayName === "function" ? e?.displayName?.() : e?.displayName);
            },
            valueExpr: 'queryName',
            items: metrics as any,
            width: 140,
            onValueChanged(e) {
                let tabOrWidget = self.config.activeTabOrWidget();
                if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                    return;
                }
                let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                if (e.value !== reportConfig.topBottomGroupByFieldName()) {
                    reportConfig.topBottomGroupByFieldName(e.value);
                }

                repaintToolbar();
            },
            disabled: disabledAllGroupBy,
        };
    }

    function getItems(self: IReportToolBarViewModel) {
        let config = self.config;
        let forceUpdateDataSource = ko.observable(true);

        let locateInMenuAlwaysMobile = isMobile() ? "always" : "auto";

        let pdfOptions = [
            {
                icon: 'picture_as_pdf',
                name: 'PDFLandscape',
                title: 'Landscape',
                tooltip: 'PDF Landscape'
            },
            {
                icon: 'picture_as_pdf',
                name: 'PDFTemplate',
                title: 'Template',
                tooltip: 'PDF Template',
            }            
        ];
        if (!isMobile()) {
            pdfOptions.push({
                icon: 'print',
                name: 'Print',
                title: 'Print',
                tooltip: 'Print'
            });
        }

        let items = [
            {
                location: 'before',
                widget: 'dxButton',
                locateInMenu: locateInMenuAlwaysMobile,
                options: {
                    hint: 'Edit Report',
                    template: `<i class="ms">edit_document</i> Edit`,
                    elementAttr: {
                        class: "intro-edit-report",
                    },
                    onClick(e) {
                        Ir.Components.ReportDesigner.ReportDesigner.showEditor(config.activeTabOrWidget());
                    },
                },
                visible: ko.computed(function () {
                    if (isMobile()) {
                        return false;
                    }
                    return workbook.workbookConfig.generalSettings.editing();
                }),
                disabled: ko.computed(function () {
                    return !self.visibleIsReportConfig();
                }),
            },
            {
                location: 'before',
                widget: 'dxButton',
                locateInMenu: locateInMenuAlwaysMobile,
                options: {
                    hint: 'Change Report Type',
                    text: self.reportTypeIconText,
                    icon: self.reportTypeIcon,
                    template: `<i class="ms" data-bind="text: icon"></i> <span data-bind="text: text"></span> <i class="ms">arrow_drop_down</i>`,
                    elementAttr: {
                        class: "intro-change-report-type",
                    },
                    onClick(e) {
                        e.event.stopPropagation();

                        self.reportTypeAction.option("target", e.element);
                        self.reportTypeAction.show();
                    },
                    onInitialized(e) {
                        self.$reportTypeAction = e.element;
                    }, 
                },
                disabled: ko.computed(function () {
                    return !self.visibleIsReportConfig() || workbook.workbookConfig.userEditMode === WorkbookEditModeEnum.Restricted;
                }),
            },
            {
                //Hidden. It can be used in the future
                location: 'before',
                widget: 'dxButton',
                visible: false,
                locateInMenu: locateInMenuAlwaysMobile,
                options: {
                    hint: 'Refresh',
                    template: `<i class="ms">refresh</i> Refresh`,
                    onClick(e) {
                        workbook.workbookConfig.activeTab().refresh();
                    },
                },
            },
            {
                //Hidden. It can be used in the future
                location: 'before',
                widget: 'dxButton',
                locateInMenu: locateInMenuAlwaysMobile,
                visible: ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
                    return false;
                    return this()?.tabType() === TabTypeEnum.Dashboard;
                }, self.config.activeTab),
                disabled: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                    return this()?.tabOrWidget === TabOrWidgetEnum.Tab;
                }, self.config.activeTabOrWidget),
                options: {
                    hint: 'Refresh Widget',
                    template: `<i class="ms">source_notes</i> <span>Refresh Widget</span>`,
                    onClick(e) {
                        workbook.workbookConfig.activeTabOrWidget().refresh();
                    },
                },
            },
            {
                //Hidden. It can be used in the future
                location: 'before',
                widget: 'dxButton',
                locateInMenu: locateInMenuAlwaysMobile,
                visible: ko.computed(function (this: KnockoutObservable<WorkbookTab>) {
                    return false;
                //     return this()?.tabType() === TabTypeEnum.Dashboard;
                }, self.config.activeTab),
                // disabled: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                //     return this()?.tabOrWidget === TabOrWidgetEnum.Tab;
                // }, self.config.activeTabOrWidget),
                options: {
                    hint: 'Refresh Drilldown',
                    template: `<i class="ms">source_notes</i> <span>Refresh Drilldown</span>`,
                    onClick(e) {
                        workbook.workbookConfig.activeTabOrWidget().drilldownManager.refresh();
                    },
                },
            },
            {
                location: 'before',
                template: `<span class="intro-analyze-by-label">Analyze By<span>`,
                locateInMenu: "auto",
                visible: !isMobile() && workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted,
            },
            {
                location: 'before',
                widget: 'dxLookup',
                locateInMenu: "auto",
                visible: workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted,
                options: {
                    elementAttr: {
                        class: "intro-analyze-by",
                    },
                    items: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        forceUpdateDataSource();//Hack to reload items when changing order

                        var tabOrWidget = this();
                        if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                            return [];
                        }
                        let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                        
                        let items = reportConfig.reportTemplateListForAnalyzeBy.map(item => ({
                            ...item,
                            name: typeof item.name === "function" ? item.name : replaceBasicHtmlContent(item.name),
                            visible: item.id === ReportConfig.reportIdOfNoneOrCustomDisplayAnalyzeByName ? item.visible : ko.computed(function () { return item.visibility === VisibilityEnum.Normal })
                        }));

                        items = items.sort(MappingService.sortFields);

                        return items;
                    }, config.activeTabOrWidget) as any,
                    value: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        var tabOrWidget = this();
                        if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                            return null;
                        }
                        let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                        return reportConfig.templateId();
                    }, config.activeTabOrWidget),
                    onValueChanged(e) {
                        let tabOrWidget = config.activeTabOrWidget();
                        if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                            return;
                        }
                        let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                        if (e.value !== reportConfig.templateId()) {
                            //Go back to the root level before refreshing
                            //tabOrWidget.drilldownManager.rollUp();
                            reportConfig.templateId(e.value);
                            let drilldown = reportConfig.reportTemplateListForAnalyzeBy.find(x => x.id === e.value);
                            reportConfig.saveAnalyzeByOrGroupBy(tabOrWidget, drilldown, false, tabOrWidget.drilldownManager.isDrilldown, drilldown.name);
                        }
                    },
                    displayExpr: "name",
                    valueExpr: "id",
                    disabled: self.disableIsNotReportConfig as any,                    
                    dropDownOptions: {
                        hideOnOutsideClick: true,
                        title: "Report Templates",
                        width: 220,
                        toolbarItems: [{
                            widget: "dxButton",
                            location: "after",
                            options: {
                                icon: "ms ir-sort-by-alpha-icon",
                                hint: "Sort alphabetically",
                                elementAttr: {
                                    class: `ir-sort-fields ${loggedUser.alphabeticalOrder ? "selected" : ""}`
                                },
                                onClick(e) {
                                    loggedUser.alphabeticalOrder = !loggedUser.alphabeticalOrder;
                                    if (e.element.hasClass("selected")) {
                                        e.element.removeClass("selected");
                                    }
                                    else {
                                        e.element.addClass("selected");
                                    }

                                    forceUpdateDataSource(!forceUpdateDataSource());
                                }
                            }
                        }]
                    },
                    onInitialized(e) {
                        analyzeByLookup = e.component;
                    },
                } as DevExpress.ui.dxLookup.Properties,
            },
            {
                location: "before",
                locateInMenu: "auto",
                template: `<span data-bind="text: $component.topBottomLabel"></span>`,
                visible: workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted
            },
            {
                location: "before",
                locateInMenu: "auto",
                widget: "dxButton",
                options: {
                    icon: "spindown",
                    text: self.topBottomText as any,
                    hint: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        var tabOrWidget = this();
                        if (tabOrWidget) {
                            let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                            if (self.disableIsNotReportConfig() || reportConfig || reportConfig.topBottom() == TopBottomEnum.All) {
                                return "All";
                            }
                            
                            return `${self.topBottomLabel()}: ${self.topBottomText()}`;
                        }

                        return "";
                    }, self.config.activeTabOrWidget) as any,
                    disabled: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        return self.disableIsNotReportConfig();
                    }, self.config.activeTabOrWidget) as any,
                    elementAttr: {
                        class: "top-bottom-text",
                    },
                    onClick(e) {
                        let reportConfig = self.config.activeTabOrWidget()?.drilldownManager?.activeReportConfig;
                        if (reportConfig && reportConfig.includeAllMetrics()) {
                            reportConfig.convertIncludeAllMetricToIndividualMetrics(() => {
                                self.topBottomPopover.show(e.element);
                            });
                        }
                        else {
                            self.topBottomPopover.show(e.element);
                        }
                    },
                    onInitialized(e) {
                        self.$topBottomButton = e.element;
                    },
                } as DevExpress.ui.dxButton.Properties,
                visible: workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted,
            }, 
            {
                location: "before",
                widget: "dxButton",
                locateInMenu: "auto",
                options: {
                    elementAttr: {
                        class: "intro-switch-analyze-by-group-by",
                    },
                    icon: "ms ir-swap_horiz-icon",
                    hint: "Switch Analyze By and Group By/Pivot On",
                    disabled: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        return !this()?.itemConfig()?.isReportConfig || (this().drilldownManager.activeReportConfig.groupReportId() ?? 0) === 0 && (this().drilldownManager.activeReportConfig.groupReportFields()[0]?.fields()?.length ?? 0) === 0;
                    }, self.config.activeTabOrWidget) as any,
                    onClick(e) {
                        let tabOrWidget = self.config.activeTabOrWidget();
                        //Go back to the root level before refreshing
                        //tabOrWidget.drilldownManager.rollUp();
                        //tabOrWidget.reportConfig.switchAnalyzeByAndGroupBy(tabOrWidget, e.element, function () {
                        tabOrWidget.drilldownManager.activeReportConfig.switchAnalyzeByAndGroupBy(tabOrWidget, function () {
                            setTimeout(repaintAnalyzeByGroupBy, 300);
                        });
                    },
                } as DevExpress.ui.dxButton.Properties,
                visible: workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted,
            },
            {
                location: 'before',
                template: `<span class="intro-group-by-label" data-bind="text: $component.groupByLabel"></span>`,
                cssClass: "group-by",
                locateInMenu: "auto",
                visible: !isMobile() && workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted,
            },
            {
                location: 'before',
                widget: 'dxLookup',
                cssClass: "group-by",
                locateInMenu: "auto",
                options: {
                    elementAttr: {
                        class: "intro-group-by",
                    },
                    items: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        forceUpdateDataSource();//Hack to reload items when changing order

                        var tabOrWidget = this();
                        if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                            return [];
                        }
                        let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                        
                        let items = reportConfig.reportTemplateListForGroupBy.map(item => ({
                            ...item,
                            name: typeof item.name === "function" ? item.name : replaceBasicHtmlContent(item.name),
                            visible: item.id === ReportConfig.reportIdOfNoneOrCustomDisplayAnalyzeByName || item.id === ReportConfig.reportIdOfCustomDisplayGroupByName ?
                                item.visible :
                                ko.computed(function () { return item.visibility === VisibilityEnum.Normal })
                        }));

                        items = items.sort(MappingService.sortFields);

                        return items;
                    }, config.activeTabOrWidget) as any,
                    value: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        var tabOrWidget = this();
                        if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                            return null;
                        }
                        let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                        return reportConfig.groupReportId();
                    }, config.activeTabOrWidget),
                    onValueChanged(e) {
                        let tabOrWidget = config.activeTabOrWidget();
                        if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                            return;
                        }
                        let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                        if (e.value !== reportConfig.groupReportId()) {
                            //Go back to the root level before refreshing
                            //tabOrWidget.drilldownManager.rollUp();
                            reportConfig.groupReportId(e.value);
                            reportConfig.saveAnalyzeByOrGroupBy(tabOrWidget, null, true, tabOrWidget.drilldownManager.isDrilldown);
                        }
                    },
                    displayExpr: "name",
                    valueExpr: "id",
                    disabled: self.disableIsNotReportConfig as any,                    
                    dropDownOptions: {
                        hideOnOutsideClick: true,
                        title: "Report Templates",
                        width: 220,
                        toolbarItems: [{
                            widget: "dxButton",
                            location: "after",
                            options: {
                                icon: "ms ir-sort-by-alpha-icon",
                                hint: "Sort alphabetically",
                                elementAttr: {
                                    class: `ir-sort-fields ${loggedUser.alphabeticalOrder ? "selected" : ""}`
                                },
                                onClick(e) {
                                    loggedUser.alphabeticalOrder = !loggedUser.alphabeticalOrder;
                                    if (e.element.hasClass("selected")) {
                                        e.element.removeClass("selected");
                                    }
                                    else {
                                        e.element.addClass("selected");
                                    }

                                    forceUpdateDataSource(!forceUpdateDataSource());
                                }
                            }
                        }]
                    },
                    onInitialized(e) {
                        groupByLookup = e.component;
                    },
                } as DevExpress.ui.dxLookup.Properties,
                visible: workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted,
            },
            {
                location: "before",
                locateInMenu: "auto",
                template: `<span data-bind="text: $component.topBottomGroupByLabel"></span>`,
                visible: workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted
            },
            {
                location: "before",
                locateInMenu: "auto",
                widget: "dxButton",
                options: {
                    icon: "spindown",
                    text: self.topBottomGroupByText as any,
                    hint: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        var tabOrWidget = this();
                        if (tabOrWidget) {
                            let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                            if (self.disableIsNotReportConfig() || reportConfig || reportConfig.topBottomGroupBy() == TopBottomEnum.All) {
                                return "All";
                            }
                            
                            return `${self.topBottomGroupByLabel()}: ${self.topBottomGroupByText()}`;
                        }

                        return "";
                    }, self.config.activeTabOrWidget) as any,
                    disabled: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        if (self.disableIsNotReportConfig()) {
                            return true;
                        }
                        var tabOrWidget = this();
                        if (!tabOrWidget?.drilldownManager?.isReportConfig) {
                            return null;
                        }
                        let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                        return !reportConfig.hasGroupBy;
                    }, self.config.activeTabOrWidget) as any,
                    elementAttr: {
                        class: "top-bottom-text intro-report-top",
                    },
                    onClick(e) {
                        e.event.stopPropagation();

                        let reportConfig = self.config.activeTabOrWidget()?.drilldownManager?.activeReportConfig;
                        if (reportConfig && reportConfig.includeAllMetrics()) {
                            reportConfig.convertIncludeAllMetricToIndividualMetrics(() => {
                                self.topBottomGroupByPopover.show(e.element);
                            });
                        }
                        else {
                            self.topBottomGroupByPopover.show(e.element);
                        }
                    },
                    onInitialized(e) {
                        self.$topBottomGroupByButton = e.element;
                    },
                } as DevExpress.ui.dxButton.Properties,
                visible: workbook.workbookConfig.userEditMode !== WorkbookEditModeEnum.Restricted,
            },            
            /******************************************************************************************************************/
            /**************************************************** AFTER *******************************************************/
            /******************************************************************************************************************/
            {
                location: 'after',
                widget: 'dxButton',
                locateInMenu: "auto",
                options: {
                    hint: 'Row Selection',
                    template: `<i class="ms">touch_app</i> Row Selection`,
                    visible: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        return self.visibleIsReportConfig() && (this().widgetType() === WidgetType.Pivot || this().widgetType() === WidgetType.Report);
                    }, self.config.activeTabOrWidget) as any,
                    onClick(e) {
                        let tabOrWidget = self.config.activeTabOrWidget();
                        tabOrWidget.reportConfig.enableRowSelection(!tabOrWidget.reportConfig.enableRowSelection());
                    },
                } as DevExpress.ui.dxButton.Properties,
            },
            {
                location: 'after',
                widget: 'dxButton',
                locateInMenu: "auto",
                options: {
                    hint: 'Search Box',
                    template: `<i class="ms">search</i> Search Box`,
                    visible: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        return self.visibleIsReportConfig() && (this().widgetType() === WidgetType.Pivot || this().widgetType() === WidgetType.Report);
                    }, self.config.activeTabOrWidget) as any,
                    onClick(e) {
                        let tabOrWidget = self.config.activeTabOrWidget();
                        tabOrWidget.reportConfig.enableSearchBox(!tabOrWidget.reportConfig.enableSearchBox());
                    },
                } as DevExpress.ui.dxButton.Properties,
            },
            {
                location: 'after',
                widget: 'dxButton',
                locateInMenu: "auto",
                options: {
                    hint: 'Enables on screen Filter and Sort. Entered data selections are NOT saved and totals are recalculated.',
                    template: `<i class="ms">filter_alt</i> Refine`,
                    visible: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                        return this()?.widgetType() === WidgetType.Pivot;
                    }, self.config.activeTabOrWidget),
                    onClick(e) {
                        let tabOrWidget = self.config.activeTabOrWidget();
                        tabOrWidget.reportConfig.enableFilterPanel(!tabOrWidget.reportConfig.enableFilterPanel());
                    },
                },
            },
            {
                location: 'after',
                widget: 'dxButton',
                locateInMenu: "auto",
                options: {
                    hint: 'Order By',
                    template: `<i class="ms">sort</i> Order By`,
                    visible: self.visibleIsReportConfig,
                    onClick(e) {
                        Ir.Components.Workbook.Settings.OrderByFieldsPopup.showOrderFieldsPopup();
                    },
                    disabled: ko.computed(() => {
                        if (!self.visibleIsReportConfig()) {
                            return true;
                        } 

                        let tabOrWidget = self.config.activeTabOrWidget();
                        let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                        return reportConfig.topBottom() !== TopBottomEnum.All || reportConfig.topBottomGroupBy() !== TopBottomEnum.All;
                    })
                },
            },
            {
                location: 'after',
                locateInMenu: "auto",
                widget: 'dxDropDownButton',
                options: {
                    width: 90,
                    displayExpr: "title",
                    items: pdfOptions,
                    splitButton: true,
                    hint: 'PDF Portrait',
                    text: 'PDF',
                    icon: 'ms-icon',
                    onButtonClick(e) {
                        workbook.workbookConfig.activeTabOrWidget().exportToPDF(false, null);
                    },
                    onItemClick(e) {
                        switch (e.itemData.name) {
                            case "PDFLandscape":
                                workbook.workbookConfig.activeTabOrWidget().exportToPDF(true, null);
                                break;
                            case "PDFTemplate":
                                workbook.workbookConfig.workbookHelper.showPDFTemplate((pdfTemplateId, landscape) => {
                                    workbook.workbookConfig.activeTabOrWidget().exportToPDF(landscape, pdfTemplateId);                                    
                                });
                                break;
                            case "Print":
                                workbook.workbookConfig.activeTabOrWidget().print();    
                                break;
                            default:
                        }
                    },
                    itemTemplate(itemData) {
                        let $div = $('<div>').css("height", 26).css("padding-top", 3)
                        $div.append($('<i>')
                            .text(itemData.icon)
                            .addClass('ms'));
                        $div.append($('<span>')
                            .text(itemData.title).attr("title", itemData.tooltip));
                        return $div;
                    },
                    onContentReady(e) {
                        $(".dx-icon-ms-icon", e.element).append("picture_as_pdf").addClass("ms").removeClass("dx-icon-ms-icon dx-icon");
                    }
                },
                visible: ko.computed(function (this: KnockoutObservable<ITabOrWidget>) {
                    let widget: ITabOrWidget = null;
                    if (self.config.activeTab().tabType() === TabTypeEnum.Dashboard) {
                        widget = self.config.activeTab() !== self.config.activeTabOrWidget() ? self.config.activeTabOrWidget() : null;
                    }
                    else {
                        widget = self.config.activeTab();
                    }

                    return loggedUser.permissions.printExportPDF() && widget &&
                        (widget.widgetType() === WidgetType.Report || widget.widgetType() === WidgetType.Chart || widget.widgetType() === WidgetType.Pivot);
                }, self.config.activeTabOrWidget)
            },
            {
                location: 'after',
                locateInMenu: "auto",
                widget: 'dxDropDownButton',
                options: {
                    displayExpr: "title",
                    items: [
                        {
                            icon: 'file_save',
                            name: EmailFormatEnum.ExcelWithoutHeaders,
                            title: 'Simple XLSX',
                            tooltip: 'Download as a XLSX without Headers file'
                        },
                        {
                            icon: 'file_save',
                            name: EmailFormatEnum.CSV,
                            title: 'CSV',
                            tooltip: 'Download as a CSV file'
                        },
                        {
                            icon: 'file_save',
                            name: EmailFormatEnum.CSVWithoutHeaders,
                            title: 'Simple CSV',
                            tooltip: 'Download as a CSV without Headers file'
                        }
                    ],
                    dropDownOptions: {
                        width: 100
                    },
                    splitButton: true,
                    hint: 'Download as a XLSX file',
                    text: 'XLSX',
                    icon: 'ms-icon',
                    onButtonClick(e) {
                        workbook.workbookConfig.activeTabOrWidget().exportToXLSX(false);
                    },
                    onItemClick(e) {
                        switch (e.itemData.name) {
                            case EmailFormatEnum.ExcelWithoutHeaders:
                                workbook.workbookConfig.activeTabOrWidget().exportToXLSX(true);
                                break;
                            case EmailFormatEnum.CSV:
                                workbook.workbookConfig.activeTabOrWidget().exportToCSV(false);
                                break;
                            case EmailFormatEnum.CSVWithoutHeaders:
                                workbook.workbookConfig.activeTabOrWidget().exportToCSV(true);
                                break;
                            default:
                        }                        
                    },
                    itemTemplate(itemData) {
                        let $div = $('<div>').css("height", 26).css("padding-top", 3)
                        $div.append($('<i>')
                            .text(itemData.icon)
                            .addClass('ms'));
                        $div.append($('<span>')
                            .text(itemData.title).attr("title", itemData.tooltip));
                        return $div;
                    },
                    onContentReady(e) {
                        $(".dx-icon-ms-icon", e.element).append("file_save").addClass("ms").removeClass("dx-icon-ms-icon dx-icon");
                    }
                },
                visible: ko.computed(function () {
                    let widget: ITabOrWidget = null;
                    if (self.config.activeTab().tabType() === TabTypeEnum.Dashboard) {
                        widget = self.config.activeTab() !== self.config.activeTabOrWidget() ? self.config.activeTabOrWidget() : null;
                    }
                    else {
                        widget = self.config.activeTab();
                    }

                    return loggedUser.permissions.exportExcelCSV() && widget &&
                        (widget.widgetType() === WidgetType.Report || widget.widgetType() === WidgetType.Chart || widget.widgetType() === WidgetType.Pivot);
                })
            },
            {
                location: 'after',
                locateInMenu: "auto",
                widget: 'dxButton',
                template: function () {
                    let template = $(`<send-emailnow-button params="activeTab: $data.activeTab"></send-emailnow-button>`);
                    ko.applyBindings({ activeTab: config.activeTab }, template.get(0));
                    return template;
                },
                visible: ko.computed(function () {
                    return config.activeTab().tabType() !== TabTypeEnum.Dashboard && loggedUser.permissions.sendEmail() && (loggedUser.permissions.printExportPDF() || loggedUser.permissions.exportExcelCSV())
                })
            },
            {
                location: 'after',
                locateInMenu: "auto",
                widget: 'dxButton',
                options: {
                    hint: 'View SQL',
                    template: `<i class="ms">code_blocks</i> View SQL`,
                    onClick(e) {
                        workbook.workbookConfig.workbookHelper.showSQL();
                    },
                },
                visible: ko.computed(function () {
                    return workbook.workbookConfig.generalSettings.editing() && loggedUser.permissions.viewSQL();
                })
            },
        ];

        return items;
    }

    export async function repaintToolbar() {
        //dxToolbarComponent?.repaint();
        if (dxToolbarComponent && (dxToolbarComponent as any).isReady()) {
            (dxToolbarComponent as any)._render();
        }
    }

    export function repaintAnalyzeByGroupBy() {
        analyzeByLookup?.repaint();
        groupByLookup?.repaint();
    }
}